import { render, staticRenderFns } from "./CatalogConfiguration.vue?vue&type=template&id=699da615&scoped=true"
import script from "./CatalogConfiguration.vue?vue&type=script&lang=js"
export * from "./CatalogConfiguration.vue?vue&type=script&lang=js"
import style0 from "./CatalogConfiguration.vue?vue&type=style&index=0&id=699da615&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699da615",
  null
  
)

export default component.exports